import type { Struct, TrackingMessage } from "@pdfking/planner"
import type { EnumType } from "@pdfking/structs"
import type { StringGUID } from "@pdfking/tfunc"

export const enum WireEnum {
  TASK = "m",
  INPUT = "i",
  OUTPUT = "o",
  TRACKING = "t",
}

export type TaskOptions = EnumType<
  WireEnum.TASK,
  {
    // set when the run asked to drop this task's cached response and re-run
    cache_evict?: boolean
    guid: StringGUID
    value: { name: string; data: Struct }
  }
>

export type WireInput = EnumType<WireEnum.INPUT, { value: unknown }>

export type WireOutput = EnumType<WireEnum.OUTPUT, { value: unknown }>

export type WireTracking = EnumType<WireEnum.TRACKING, { value: TrackingMessage }>

export type WireRequest = TaskOptions | WireInput

export type WireResponse = WireOutput | WireTracking
